import React from "react";
import { VotingRecordItem } from "../../../models/stewardshipModels";
import { CompassParagraph } from "../styledComponents";
import { CompassModal, ModalContent, ModalFooter } from "../Modal";

import notification from "../../../assets/svg/notification.svg";
import {
  HorizontalLine,
  RowContainer,
} from "../../containers/styledComponents";
import { greyText } from "../../../styles";
import { CompanyLogo } from "../../tables/CompanyLogo";
import { CompanySummary } from "../../../models/CompanyprofileModels";
import { MESSAGES } from "../../../messages";
import { formatReadableDate } from "../../../utils/formattingUtils";
import { ContentBox } from "../ContentBox";
import { getContentBoxRows } from "./utils";
import { VotingDataSourceType } from "../../../models/tableModels";

export const VotingRecordModal: React.FC<{
  companySummaryData: CompanySummary | null;
  data: VotingRecordItem[];
  votingTableData: VotingDataSourceType[];
  modalRecordId: string | null;
  onHide: () => void;
  shouldDisplay?: boolean;
}> = ({ companySummaryData, data, shouldDisplay, modalRecordId, onHide }) => {
  const votingRecord =
    data.find((record) => record.voting_record_id === modalRecordId) || null;

  const companyLogoProps = {
    name: companySummaryData?.name ?? "",
    logoUrl: companySummaryData?.image ?? "",
  };

  const proposalDate = votingRecord?.proposal_date
    ? formatReadableDate(votingRecord.proposal_date)
    : MESSAGES.NOT_AVAILABLE;

  const headerRight = <CompanyLogo {...companyLogoProps} size={"md"} />;

  const footerContent = (
    <ModalFooter onClose={onHide} hideSubmit showDivider={false} />
  );

  return (
    <CompassModal
      show={shouldDisplay ?? false}
      handleClose={onHide}
      size="lg"
      title="Voting Activity"
      titleIcon={notification}
      headerRight={headerRight}
      modalType="md"
      footer={footerContent}
    >
      <ModalContent>
        <RowContainer mb={-5}>
          <CompassParagraph fontSize={15} bold={true}>
            {`Proposal: ${
              votingRecord?.proposal_text || MESSAGES.NOT_AVAILABLE
            }`}
          </CompassParagraph>
        </RowContainer>
        <RowContainer>
          <CompassParagraph fontSize={13} bold={true} color={greyText}>
            {`Date: ${proposalDate}`}
          </CompassParagraph>
        </RowContainer>
        <HorizontalLine marginTop={1} />
        {getContentBoxRows(votingRecord).map((row, rowIndex) => (
          <RowContainer key={rowIndex}>
            {row.map((box, boxIndex) => (
              <ContentBox
                key={boxIndex}
                title={box.title}
                content={box.content}
              />
            ))}
          </RowContainer>
        ))}
      </ModalContent>
    </CompassModal>
  );
};
